<template>
  <q-dialog
    v-bind="attrs"
    ref="modalRef"
    :model-value="modelValue"
    :maximized="!noMaximized"
    :persistent="persistent"
    @hide="$emit('hide')"
  >
    <div
      class="bg-transparent modal-wrapper q-pa-md-lg"
      @mousedown.self="$emit('hide')"
    >
      <q-card
        :class="['modal-content q-mx-auto column border-radius-20', contentClass]"
        :style="contentStyle"
      >
        <q-card-section
          v-if="showHeader"
          :class="['row items-center justify-between q-px-md modal-header', headerClass]"
        >
          <slot name="left-header"/>
          <div class="row items-center full-width">
            <div
              v-if="title"
              class="fs-20 text-weight-medium q-mr-md col"
            >
              {{ title }}
            </div>
            <slot name="header"/>
          </div>

          <q-btn
            v-if="showCloseBtn"
            v-close-popup
            flat
            round
            dense
            class="q-ml-lg"
            :style="closeBtnStyle"
          >
            <q-icon
              name="img:/close.svg"
              class="text-grey"
              size="14px"
            />
          </q-btn>
        </q-card-section>

        <q-card-section
          v-if="$slots.default"
          :class="['q-pa-none scroll modal-body-section', bodyClass]"
        >
          <slot/>
        </q-card-section>

        <q-card-actions
          v-if="$slots.footer"
          :class="['q-pa-none', footerClass]"
          bor
        >
          <slot name="footer"/>
        </q-card-actions>
      </q-card>
    </div>
  </q-dialog>
</template>

<script setup>
import {
 useAttrs, useSlots, computed, ref,
} from 'vue';

defineEmits(['hide', 'submit']);

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  noMaximized: {
    type: Boolean,
    default: false,
  },
  showCloseBtn: {
    type: Boolean,
    default: false,
  },
  contentStyle: {
    type: [String, Object],
    default: undefined,
  },
  contentClass: {
    type: [String, Object, Array],
    default: undefined,
  },
  headerClass: {
    type: [String, Object, Array],
    default: undefined,
  },
  bodyClass: {
    type: [String, Object, Array],
    default: undefined,
  },
  footerClass: {
    type: [String, Object, Array],
    default: undefined,
  },
  title: {
    type: String,
    default: undefined,
  },
  persistent: {
    type: Boolean,
    default: false,
  },
  closeBtnStyle: {
    type: [String, Object],
    default: undefined,
  },
});

const attrs = useAttrs();
const slots = useSlots();

const modalRef = ref(null);

const showHeader = computed(() => (props.title || props.showCloseBtn || slots.header));

defineExpose({ modalRef });
</script>

<style lang="scss" scoped>
.modal-wrapper {
  box-shadow: none;
  overflow: unset;
}
.modal-content {
  z-index: 3000;
  min-width: 375px;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: none;
}

.q-dialog__inner > div {
  max-height: none;
}

.dialog__inner {
  overflow: scroll;
}

.modal-header {
  width: 100%;
  height: 70px;
  border-bottom: thin solid rgba(0, 36, 82, 0.12);
  flex-wrap: nowrap;
}
</style>
